import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = {
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 200 200",
  style: {"width":"100%","height":"100%"}
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M153.3 122.8c2.1-7.1 3.1-15.4 3.1-24.9 0-9.8-1.3-18.4-3.9-25.6-2.7-7.4-6.7-13.4-11.9-17.7-5.1-4.2-11.1-7.4-17.8-9.3-6.5-1.9-14.1-2.9-22.6-2.9-8.5 0-16.2 1-22.8 2.9-6.8 1.9-12.8 5.1-17.9 9.3-5.2 4.4-9.3 10.3-12 17.7-2.6 7.2-4 15.8-4 25.6 0 20.6 5 35.8 14.8 45.1 9.8 9.3 23.8 10.3 41.6 10.3 8.1 0 15.5-.2 22-1.3v18.6c23.2-10.8 31.1-46.3 31.4-47.8zM102.4 198c-14.2 0-26.5-1.3-36.6-3.8-10.2-2.3-19.6-6-28-10.9-7.6-4.9-14.1-11.2-19.2-18.7-5.2-7.6-9.3-17.1-12.2-28.3C3.5 125 2 112 2 97.6c0-17 2.2-31.9 6.6-44.3C13 41.1 19.3 31.3 27.3 24c8.4-7.2 18.8-12.7 30.9-16.3C70.4 3.9 84.6 2 100.3 2c15.7 0 29.8 1.9 41.9 5.7 12 3.6 22.3 9.2 30.7 16.5 8 7.2 14.2 17.1 18.5 29.4C195.8 66 198 81 198 98c0 17.9-2.2 33.6-6.6 46.6-4.3 12.8-10.6 23.1-18.8 30.7-8.3 7.7-18.6 13.4-30.6 17-12.1 3.8-25.5 5.7-39.6 5.7zm23.7-117.8v17.3c0 13.6-11.6 24.7-26 24.7s-26-11.1-26-24.7V80.2h52z"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("span", {
    class: "tri-icon",
    style: _normalizeStyle(`font-size: ${_ctx.size}; color: ${_ctx.color}; width: 1em; height: 1em; display:block; line-height: 0;`)
  }, [
    (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
  ], 4))
}